import { Button, Col, Form } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import t from '../../../text';
import usePreviousBookingLoginState, { usePreviousBookingLoginActions } from './usePreviousBookingLogin';
import { RequestErrors } from '../RequestErrors';
import { required } from '../../utils/validation';
import { TextInput } from '../FormElements';

export const validateField = (values) => {
  const errors = {};
  if (!required(values.bookingId)) {
    errors.bookingId = t('forms.previousBooking.blankBookingId');
  }
  if (!required(values.surname)) {
    errors.surname = t('forms.previousBooking.blankSurname');
  }
  if (!required(values.postcode)) {
    errors.postcode = t('forms.previousBooking.blankPostcode');
  }
  return errors;
};

// This page logs you into a previous booking
export const PreviousBookingLogin = ({ onClose }) => {
  const history = useHistory();

  const { getMyBookingError, isValid, validate, values, errors, onChange } = usePreviousBookingLoginState();
  const { bookingId, surname, postcode } = values;

  const { previousBookingLogin } = usePreviousBookingLoginActions();

  const redirectToPage = (booking) => {
    history.push('/my-booking', { booking });
  };

  const handleBookingClick = (event) => {
    event.preventDefault();
    validate();

    if (isValid()) {
      previousBookingLogin(bookingId, surname, postcode).then((response) => {
        const baseResponse = response.payload.response.data;
        const wasSuccessful = baseResponse.success === 1;
        const bookingData = baseResponse.data;

        if (wasSuccessful) {
          redirectToPage(bookingData);
          onClose?.();
        }
      });
    }
  };

  return (
    <Form name="loginForm" noValidate>
      <Form.Row>
        <Col sm={12} md={4}>
          <Form.Label>{t('booking.payment.bookingReference')}</Form.Label>
          <TextInput
            name="bookingId"
            type="text"
            value={bookingId}
            onChange={(e) => onChange(e.target.name, e.target.value)}
            invalid={!!errors.bookingId}
            validationMessage={errors.bookingId}
          />
        </Col>
        <Col sm={12} md={4}>
          <Form.Label>{t('booking.payment.surname')}</Form.Label>
          <TextInput
            name="surname"
            type="text"
            value={surname}
            onChange={(e) => onChange(e.target.name, e.target.value)}
            invalid={!!errors.surname}
            validationMessage={errors.surname}
          />
        </Col>
        <Col sm={12} md={4}>
          <Form.Label>{t('booking.payment.postcode')}</Form.Label>
          <TextInput
            name="postcode"
            type="text"
            value={postcode}
            onChange={(e) => onChange(e.target.name, e.target.value)}
            invalid={!!errors.postcode}
            validationMessage={errors.postcode}
          />
        </Col>
      </Form.Row>

      <RequestErrors requestError={getMyBookingError} />

      <Form.Row className="mt-3 mt-md-2">
        <Col sm={12} md={6}>
          <Button type="submit" block onClick={handleBookingClick}>
            {t('buttons.submit')}
          </Button>
        </Col>
      </Form.Row>
    </Form>
  );
};
